export const RANGEMIN = 0;
export const RANGEMAX = 1000000;
